import Image from 'next/image';
import s from './MasterplanList.module.css';
import { MasterplanListProps } from '@/types/model';
import { ImageLoader } from '@/lib/imageLoader';
import { motion } from 'framer-motion';

const MasterplanList = ({ items }: MasterplanListProps) => {
  return (
    <div className={s.container}>
      {items.map((item) => (
        <motion.div
          whileInView={{ opacity: [0, 1], transition: { duration: 1, delay: 0.2 } }}
          key={item.title}
          className={s.container__item}>
          <h3>{item.title}</h3>
          <Image
            src={ImageLoader({ src: item.logo?.url })}
            alt="logo"
            height={65}
            width={360}
            quality={70}
            sizes="360px"
          />
          <p>{item.description}</p>
        </motion.div>
      ))}
    </div>
  );
};

export default MasterplanList;
